import config from '../../configs/config';

export async function parseJsonResponse(response) {
  const responseText = await response.text();
  const normalizedText = responseText.trim();

  try {
    return JSON.parse(normalizedText);
  } catch (initialError) {
    const withoutArrayPrefix = normalizedText.replace(/^Array\s*/i, '');

    try {
      return JSON.parse(withoutArrayPrefix);
    } catch (arrayPrefixError) {
      const jsonStart = withoutArrayPrefix.indexOf('{');
      const jsonEnd = withoutArrayPrefix.lastIndexOf('}');

      if (jsonStart >= 0 && jsonEnd > jsonStart) {
        const extractedJson = withoutArrayPrefix.slice(jsonStart, jsonEnd + 1);
        return JSON.parse(extractedJson);
      }

      throw initialError;
    }
  }
}

export function buildSearchParams(query) {
  const params = new URLSearchParams();

  Object.keys(query).forEach((key) => {
    const value = query[key];

    if (value !== undefined && value !== null) {
      params.append(key, value);
    }
  });

  return params;
}

function appendFormParam(params, key, value) {
  if (value === undefined || value === null) {
    return;
  }

  if (Array.isArray(value)) {
    value.forEach((item, index) => {
      if (item !== null && typeof item === 'object') {
        appendFormParam(params, `${key}[${index}]`, item);
      } else {
        appendFormParam(params, `${key}[]`, item);
      }
    });
    return;
  }

  if (typeof value === 'object') {
    Object.keys(value).forEach((nestedKey) => appendFormParam(params, `${key}[${nestedKey}]`, value[nestedKey]));
    return;
  }

  params.append(key, value);
}

export function buildFormParams(payload) {
  const params = new URLSearchParams();
  Object.keys(payload).forEach((key) => appendFormParam(params, key, payload[key]));
  return params;
}

async function request(requestUrl, fetchOptions, { networkErrorMessage, resultErrorMessage, fallbackErrorMessage }) {
  const response = await fetch(requestUrl, fetchOptions);
  const jsonResponse = await parseJsonResponse(response);

  if (!response.ok) {
    throw new Error(networkErrorMessage || fallbackErrorMessage);
  }

  if (!jsonResponse.result) {
    const error = new Error(jsonResponse.errorMessage || resultErrorMessage || fallbackErrorMessage);
    error.payload = jsonResponse;
    throw error;
  }

  return jsonResponse;
}

export function getJson(method, query = {}, options = {}) {
  const queryString = buildSearchParams(query).toString();

  console.log(`Requesting ${method} with query: ${queryString}`);
  const requestUrl = `${config.apiurl}${method}${queryString ? `?${queryString}` : ''}`;

  return request(requestUrl, {
    method: 'GET',
    headers: {
      Accept: 'application/json'
    }
  }, {
    networkErrorMessage: options.networkErrorMessage,
    resultErrorMessage: options.resultErrorMessage,
    fallbackErrorMessage: options.errorMessage || `${method} request failed`
  });
}

export function postForm(method, payload, options = {}) {
  const requestUrl = `${config.apiurl}${method}`;

  return request(requestUrl, {
    method: 'POST',
    headers: {
      Accept: 'application/json'
    },
    body: buildFormParams(payload)
  }, {
    networkErrorMessage: options.networkErrorMessage,
    resultErrorMessage: options.resultErrorMessage,
    fallbackErrorMessage: options.errorMessage || `${method} request failed`
  });
}
